namespace advisorop.identity {

    /// How a system login is allowed to authenticate, and the words an administrator reads for it.
    ///
    /// The wording lives here rather than in each of the three lists that offer the control, for
    /// the same reason TwoFactorExemption exists: three copies of a sentence about a security
    /// setting is three chances for them to drift and for one of them to describe the wrong thing.
    ///
    /// The labels describe the effect on the person, not the name of the flag. "Salesforce only"
    /// says that the password will stop working; "REQUIRED" does not.
    export class SsoModeOption {

        static DISABLED = 0;
        static ALLOWED = 1;
        static REQUIRED = 2;

        static all(): { value: number, label: string }[] {
            return [
                { value: SsoModeOption.DISABLED, label: "Password only" },
                { value: SsoModeOption.ALLOWED, label: "Password or Salesforce" },
                { value: SsoModeOption.REQUIRED, label: "Salesforce only" }
            ];
        }

        static label(mode: number): string {
            const match = SsoModeOption.all().filter(o => o.value === (mode || 0))[0];
            return match ? match.label : "Password only";
        }

        /// Asks before the one change that can leave somebody unable to sign in at all. Returns
        /// true to go ahead.
        ///
        /// Nothing here can tell whether the person actually has a Salesforce identity - that is
        /// only known once they try - so this warns rather than pretends to verify.
        static confirm(mode: number, who: string): boolean {
            if (mode !== SsoModeOption.REQUIRED)
                return true;

            return window.confirm(
                `Require ${who} to sign in with Salesforce?\n\n` +
                `Their password will stop working immediately. If their Salesforce account is not ` +
                `linked to this login, they will not be able to sign in at all.`);
        }

        /// What the administrator is told once it is done.
        static message(mode: number, who: string): string {
            switch (mode) {
                case SsoModeOption.REQUIRED:
                    return `${who} must now sign in with Salesforce. Their password no longer works.`;
                case SsoModeOption.ALLOWED:
                    return `${who} can now sign in with Salesforce or with their password.`;
                default:
                    return `${who} signs in with their password. Salesforce sign-in is off for them.`;
            }
        }
    }
}
